export class MnInformeTerceraRequest {
    identSolicitud?: number | null;
}

export class MnSaveInformeTerceraRequest {
    identSolicitud?: number | null;
    giroNegocioId?: number | null;
}